import { displayPrice } from "@utils/pricing";
import { NO_VALUE } from "@utils/constants";
import * as StyledOrder from "../OrderSummary.styled";
import * as Styled from "./Total.styled";

export interface TotalProps {
  className?: string;
  hasBundle: boolean;
  orderTotal: string;
  shadowPrices?: boolean;
  savings: number;
}

const Total = ({ className, hasBundle, orderTotal, savings, shadowPrices }: TotalProps) => {
  const orderTotalNumber = parseFloat(orderTotal);
  const total = shadowPrices ? NO_VALUE : displayPrice(orderTotalNumber);

  return (
    <Styled.TotalWrapper className={className}>
      <Styled.TotalHeader data-testid="savings-total">
        {"Estimated Total"}:<StyledOrder.Price>{total}</StyledOrder.Price>
      </Styled.TotalHeader>
      {/* TO DO: MIR-1019:
      Remove !hasBundle from conditional when custom order attributes are added. */}
      {/* {savings > 0 && ( */}
      {savings > 0 && !hasBundle && (
        <Styled.DescriptionWrapper>
          You saved {displayPrice(savings, true)}!
        </Styled.DescriptionWrapper>
      )}
    </Styled.TotalWrapper>
  );
};
export default Total;
